import React, { useRef } from "react";
import { Popup } from "semantic-ui-react";
import FilterPresetContent from "./FilterPresetContent";
import { type AxiosPromise } from "axios";
import { type FilterValues } from "../FilterContext";
import { type AxiosPromiseWithRequest } from "components/ListTemplate/types";
import { PhosphorStarButton } from "components/Atoms/PhosphorIconButton";
import { HorizontalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";

interface Props<TInstruction, TItem, TFilter> {
  cacheKey: string
  filterSet: server.dto.FilterSets
  listApi: () => AxiosPromise<server.dto.ApiResponseWrapper<server.dto.FilterPreset<TInstruction>[]>>
  mutateApi: (instruction: server.dto.CreateFilterPresetInstruction<TInstruction>) => AxiosPromise<any>
  instruction: TInstruction
  fetchFunction: (instruction: TInstruction) => AxiosPromiseWithRequest<TItem, TFilter>
  mapResponseToFilterValues: (response: TFilter, values: FilterValues) => Partial<FilterValues>
  onApplyPreset: (preset: server.dto.FilterPreset<TInstruction>) => void
}

const FilterPresetButton = <I extends any, T extends any, F extends any>(props: Props<I, T, F>) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const onClose = () => {
    setIsOpen(false);
    triggerRef.current?.focus();
  }

  return <div className="selectiontool-header-presets-button" title={RESX.SelectionManager.FilterPresets}>
    <Popup
      className="myselection-tooltip"
      trigger={<PhosphorStarButton
        {...HorizontalKeyboardNavigationGroup("filterHeader")}
        ref={triggerRef}
        layout="none"
      />}
      content={<FilterPresetContent {...props} onClose={() => { setIsOpen(false); }} />}
      open={isOpen}
      onOpen={() => { setIsOpen(true); }}
      onClose={onClose}
      style={{ width: 500 }}
      openOnTriggerClick
      closeOnTriggerClick={false}
      on="click"
      position="bottom right"
    />
  </div>;
};

export default FilterPresetButton;